import { Reducer } from 'redux'
import { DateTime } from 'luxon'

import {
  initialFilterRevenueState,
  ReportsData,
  RevenueInsightsAction,
  RevenueTrackingActionTypes,
  revenueDateTypeOptionsMap,
} from './types'

export * from './types'

export const initialState: ReportsData = {
  records: [],
  totalAmountActivated: '',
  totalAmountBilled: '',
  totalAmountDisbursed: '',
  pageSize: 15,
  pageNumber: 1,
  noOfPage: null,
  graphData: [],
  dateRange: {
    startDate: DateTime.now().minus({ months: 6 }).toISODate() as string,
    endDate: DateTime.now().toISODate() as string,
  },
  dateRangeType: revenueDateTypeOptionsMap.INVOICE,
  filters: {
    ...initialFilterRevenueState,
  },
  lastEvaluatedObject: null,
  count: 0,
  tcv: 0,
  insertDates: {},
}

export const reducer: Reducer<ReportsData, RevenueInsightsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case RevenueTrackingActionTypes.SET_REPORTS_DATA: {
      const incomingRecords = action.payload.records ?? []
      const existingRecords = state.records ?? []
      let updatedRevenue = incomingRecords

      if (action.payload.cloudMarketplace === 'AZURE') {
        const existingIds = new Set(
          existingRecords.map(record => record.itemId)
        )

        updatedRevenue = incomingRecords.filter(
          record => !existingIds.has(record.itemId)
        )
      } else if (action.payload.cloudMarketplace === 'GCP') {
        const existingIds = new Set(
          existingRecords.map(record => record.externalRecordId)
        )

        updatedRevenue = incomingRecords.filter(
          record => !existingIds.has(record.externalRecordId)
        )
      } else {
        const existingIds = new Set(
          existingRecords.map(record => record.invoiceId)
        )

        updatedRevenue = incomingRecords.filter(
          record => !existingIds.has(record.invoiceId)
        )
      }
      return {
        ...state,
        ...action.payload,
        records: existingRecords.concat(updatedRevenue),
        noOfPage: Math.ceil(action.payload.count / action.payload.pageSize),
        insertDates: {
          ...state.insertDates,
          ...action.payload?.insertDates,
        },
      }
    }
    case RevenueTrackingActionTypes.REVENUE_SET_LIMIT: {
      return {
        ...state,
        pageSize: action.payload,
      }
    }
    case RevenueTrackingActionTypes.REVENUE_SET_PAGE_NUMBER: {
      return {
        ...state,
        pageNumber: action.payload,
      }
    }
    case RevenueTrackingActionTypes.SET_DATE_RANGE: {
      return {
        ...state,
        dateRange: action.payload,
      }
    }
    case RevenueTrackingActionTypes.SET_DATE_RANGE_TYPE: {
      return {
        ...state,
        dateRangeType: action.payload,
      }
    }
    case RevenueTrackingActionTypes.SET_FILTERS: {
      return {
        ...state,
        filters: action.payload,
        lastEvaluatedObject: null,
      }
    }
    case RevenueTrackingActionTypes.CLEAR_REVENUE_REPORTS: {
      return {
        ...state,
        records: [],
        graphData: [],
        count: 0,
        totalAmountActivated: '',
        amountChange: '',
        percentageChange: '',
        totalAmountBilled: '',
        totalAmountDisbursed: '',
        lastEvaluatedObject: null,
        tcv: 0,
      }
    }
    case RevenueTrackingActionTypes.CLEAR_REVENUE_FILTERS: {
      return {
        ...state,
        filters: {
          ...initialFilterRevenueState,
        },
        lastEvaluatedObject: null,
      }
    }
    default: {
      return state
    }
  }
}
